<template>
	<div class="blue-centered-block">
		<h1 class="title">{{ title }}</h1>
		<p class="subtitle" v-if="subtitle" v-html="subtitle"></p>
	</div>
</template>

<script>
export default {
	name: 'BlueCenteredBlock',
	props: {
		title: {
			type: String,
			required: true
		},
		subtitle: {
			type: String
		}
	}
}
</script>

<style lang="scss" scoped>
.blue-centered-block {
	width: 100%;
	background-color: $blue; /* Replace with your primary color variable */
	padding: 8rem 14rem;

	@include media(mobile, tablets) {
		padding: 4rem 2rem;
	}
	text-align: center;

	.title {
		font-size: 35px;

		@include media(mobile, tablets) {
			font-size: 23px;
		}
		margin: 0;
		color: white;
	}

	.subtitle {
		font-size: 22px;
		line-height: 2.5rem;

		@include media(mobile, tablets) {
			font-size: 16px;
			line-height: 1.75rem;
		}
		margin-top: 2rem;
		color: white;
	}
}
</style>


// WEBPACK FOOTER //
// src/components/base/BlueCenteredBlock.vue